/**
 * Evaluate password strength rules against the Cognito password policy.
 *
 * @param {string} pwd — the new password being typed
 * @param {string} [currentPwd=''] — the current/old password (for "different from current" check).
 *   Omit when the user doesn't know their old password (e.g. forgot-password reset).
 * @returns {Array<{ label: string, met: boolean }>}
 */
export function getPwdRules(pwd, currentPwd = '') {
  return [
    { label: 'At least 12 characters',          met: pwd.length >= 12 },
    { label: 'One uppercase letter (A\u2013Z)',        met: /[A-Z]/.test(pwd) },
    { label: 'One lowercase letter (a\u2013z)',        met: /[a-z]/.test(pwd) },
    { label: 'One number (0\u20139)',                  met: /[0-9]/.test(pwd) },
    { label: 'One symbol (!@#$\u2026)',               met: /[^A-Za-z0-9]/.test(pwd) },
    { label: 'Different from current password',  met: pwd.length > 0 && pwd !== currentPwd },
  ];
}
